import { defineMessages, useIntl } from 'react-intl';
import { View } from '@carbon/icons-react';

import CommonButton from 'Components/Common/CommonButton/CommonButton';

type Props = {
    id: string;
    onViewDetails: (id: string) => void;
}

const ViewParishBookPersonDetails = ({
    id,
    onViewDetails,
}: Props) => {
    const intl = useIntl();

    const onOpenRequest = () => {
        onViewDetails(id);
    };

    return (
        <CommonButton
            align="bottom"
            label={intl.formatMessage(messages.editMember)}
            kind="ghost"
            iconSize={21}
            icon={<View />}
            onClick={onOpenRequest}
        />
    );
};

const messages = defineMessages({
    editMember: {
        id: 'src.Screens.Dashboard.ParishBook.ParishBookView.ViewParishBookPersonDetails.ViewParishBookPersonDetails.editMember',
        defaultMessage: 'Zobacz dane tej osoby',
    },
});

export default ViewParishBookPersonDetails;
